$(document).ready(function () {  

   $(".navbar-toggler").click(function(){
        $(".navbar-drawer").toggleClass("show");
        $(".overlay").toggleClass("show");
        $("body").toggleClass("add-fix");
       $(".inner-drawer").removeClass("show");
    });
    $(".close-btn, .overlay").click(function(){
        $(".navbar-drawer").removeClass("show");
        $(".overlay").removeClass("show");
        $(".inner-drawer").removeClass("show");
        $("body").removeClass("add-fix");
    });
    $(".navbar-drawer .navbar-links li.nav-item .nav-link").click(function(){
        $(this).siblings().addClass("show");
    });
    $(".back-inner-drawer").click(function(){
        $(this).parent().removeClass("show");
    });
    $(".inner-drawer ul li .nav-inner-links").click(function(){
        $(this).siblings().addClass("show");
    });
  
    /* **** Slider ***** */
    // $(".hero-wrp .hero-slider").slick({
    //     arrows: false,
    //     loop: true,
    //     dots: true,
    //     autoplay: true,
    //     autoplaySpeed: 4500,
    //     speed: 500,
    //     infinite: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    // });
    /* ***** End Slider **** */

    /* **** Slider ***** */
    // $(".collection-slider").slick({
    //     arrows: true,
    //     loop: true,
    //     dots: true,
    //     autoplay: false,
    //     autoplaySpeed: 4500,
    //     speed: 500,
    //     infinite: true,
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     responsive: [
    //         {
    //             breakpoint: 1900,
    //             settings: {
    //                 slidesToShow: 4,
    //             },
    //         },
    //         {
    //             breakpoint: 1600,
    //             settings: {
    //                 slidesToShow: 4,
    //             },
    //         },
    //         {
    //             breakpoint: 1400,
    //             settings: {
    //                 slidesToShow: 4,
    //             },
    //         },
    //         {
    //             breakpoint: 1199,
    //             settings: {
    //                 slidesToShow: 3,
    //             },
    //         },
    //         {
    //             breakpoint: 991,
    //             settings: {
    //                 slidesToShow: 3,
    //                 arrows: false,
    //             },
    //         },
    //         {
    //             breakpoint: 767,
    //             settings: {
    //                 slidesToShow: 2,
    //                 arrows: false,
    //             },
    //         },
    //         {
    //             breakpoint: 575,
    //             settings: {
    //                 slidesToShow: 2,
    //             },
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1,
    //                 centerMode: true,
    //                 centerPadding: '30% 0 0',
    //             },
    //         },
    //     ],
    // });
    /* ***** End Slider **** */

    /* **** Slider ***** */
    $(".sponsor-slider").slick({
        arrows: true,
        loop: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4500,
        speed: 500,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1900,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });
    /* ***** End Slider **** */

    /* **** Slider ***** */  
    $(".arrived-slider.arrived").slick({
          arrows: true,
          loop: true,
          dots: false,
          draggable:true,
          swipe: true,
          autoplay: false,
          autoplaySpeed: 5000,
          speed: 500,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
      
          responsive: [
              {
                  breakpoint: 1900,
                  settings: {
                      slidesToShow: 4,
                  },
              },
              {
                  breakpoint: 1600,
                  settings: {
                      slidesToShow: 4,
                  },
              },
              {
                  breakpoint: 1400,
                  settings: {
                      slidesToShow: 4,
                  },
              },
              {
                  breakpoint: 1199,
                  settings: {
                      slidesToShow: 3,
                  },
              },
              {
                  breakpoint: 991,
                  settings: {
                      slidesToShow: 3,
                  },
              },
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 2,
                  },
              },
              {
                  breakpoint: 575,
                  settings: {
                      slidesToShow: 2,
                  },
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '30% 0 0',
                  },
              },
          ],
      });
    /* ***** End Slider **** */

    /* **** Slider ***** */
    // $(".blog-slider").slick({
    //     arrows: true,
    //     loop: true,
    //     dots: true,
    //     autoplay: false,
    //     autoplaySpeed: 5000,
    //     speed: 1500,
    //     infinite: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     responsive: [
    //         {
    //             breakpoint: 1900,
    //             settings: {
    //                 slidesToShow: 4,
    //             },
    //         },
    //         {
    //             breakpoint: 1600,
    //             settings: {
    //                 slidesToShow: 3,
    //             },
    //         },
    //         {
    //             breakpoint: 1400,
    //             settings: {
    //                 slidesToShow: 3,
    //             },
    //         },
    //         {
    //             breakpoint: 1199,
    //             settings: {
    //                 slidesToShow: 3,
    //             },
    //         },
    //         {
    //             breakpoint: 991,
    //             settings: {
    //                 slidesToShow: 3,
    //             },
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 2,
    //             },
    //         },
    //         {
    //             breakpoint: 575,
    //             settings: {
    //                 slidesToShow: 1,
    //                 centerMode: true,
    //                 centerPadding: '30% 0 0',
    //             },
    //         },
    //         {
    //             breakpoint: 447,
    //             settings: {
    //                 slidesToShow: 1,
    //                 centerMode: true,
    //                 centerPadding: '30% 0 0',
    //             },
    //         },
    //     ],
    // });
  $('.blog-slider').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        items: 3,
        dots: 1,
        autoplayTimeout: 300,
        smartSpeed: 600,
        responsive: {
            0: {
                items: 1.5
            },
            600: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    });
    /* ***** End Slider **** */

   

    /* **** Radio Buttons **** */
    $(".hover-box ul li .checkbox-radio").change(function () {
      // if($(this).parent('.select-box').hasClass('disable')){
      // }else{        
        if ($(this).prop("checked")) {
            $(this).closest(".hover-box ul").find("li").removeClass("selected");
            $(this).closest("li").addClass("selected");
        }
      // }
    });
    /* **** End Radio Buttons **** */

    /* **** checkbox Buttons **** */
    $(".select-color-block input[type='checkbox'], .select-maat-block input[type='checkbox']").change(function() {
        if ($(this).is(":checked")) {
            $(this).closest("li").addClass("selected");
        } else {
            $(this).closest("li").removeClass("selected");
        }
    });
    /* **** checkbox Buttons **** */

    /* **** Heart **** */
    $(".heart-btn").click(function (e) {
        e.preventDefault();
        $(this).find("i").toggleClass("far fas");
    });
    /* **** End Heart **** */

    /* **** Password Input **** */
    $(".toggle-password").click(function () {
        $(this).toggleClass("show");
        var input = $($(this).attr("toggle"));
        if (input.attr("type") == "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    });
    /* **** End Password Input **** */

    /* **** Login Hide Show *** */
    $(".login-wrp .frg-btn").click(function () {
        $(".login-wrp .login-block").hide();
        $(".login-wrp .password-block").show();
    });

    $(".login-wrp .cancel-btn").click(function () {
        $(".login-wrp .password-block").hide();
        $(".login-wrp .login-block").show();
    });
    /* **** End Login Hide Show *** */

    /* **** Range Slider **** */
    // $(function() {
    //     $("#slider-range").slider({
    //         range: true,
    //         min: 0,
    //         max: 15000,
    //         values: [0, 9937],
    //         slide: function(event, ui) {
    //             $("#min-value").val(ui.values[0]);
    //             $("#max-value").val(ui.values[1]);
    //         }
    //     });

    //     $("#min-value").val($("#slider-range").slider("values", 0));
    //     $("#max-value").val($("#slider-range").slider("values", 1));
    // });

    /* **** End Range Slider **** */

    /* **** Gloves **** */
    $(function () {
        $(".gloves-slider").slick({
            infinite: true,
            variableWidth: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            swipe: true,
            // swipeToSlide: true,
            responsive: [
            {
                breakpoint: 1900,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 5,
                },
            },
        ],
        });

        $(".gloves-slider").on("afterChange", function (event, slick, currentSlide, nextSlide) {
            console.log(currentSlide);
        });
    });
    /* **** End Gloves **** */
    // Popup Prodect image
 //    $('#aniimated-thumbnials').lightGallery({
	// 	zoom : true,
 //      selector: '.slider-box',
	// 	plugins: [lgZoom,lgThumbnail],
	// 	thumbnail: true,
	// 	addClass: 'lg-custom-thumbnails',
	// 	download: false,
	// 	share: false,
 //    	autoplayControls: false,
	// 	enableDrag :false,
		
	// 	zoomFromOrigin  :true,
	// 	showZoomInOutIcons : true,
	// 	// exThumbImage: 'data-external-thumb-image',
		
	// 	// zoomPluginStrings : {zoomIn: 'Zoom in', zoomOut: 'Zoom out', viewActualSize: 'View actual size'},
	// 	scale: 1.5,
	// 	fullScreen  :false,
	// 	actualSize :false,
	// 	counter :false,
	// 	speed: 300,
		
	// 	easing: 'ease-in-out',
		
		
	// });
    


    /* **** Quantity **** */
   var current_url = window.location.href;
      console.log(current_url);
      if(current_url.includes("/cart")){
      console.log(current_url);
      }else{
         jQuery(document).ready(($) => {
            $('.quantity').on('click', '.plus', function(e) {
                let $input = $(this).prev('input.qty');
                let val = parseInt($input.val());
                $input.val( val+1 ).change();
            });
     
            $('.quantity').on('click', '.minus', 
                function(e) {
                let $input = $(this).next('input.qty');
                var val = parseInt($input.val());
                if (val > 0) {
                    $input.val( val-1 ).change();
                } 
            });
        });
      }
    /* **** End Quantity **** */




    
    $(".product-wrp .specialists-block h2 span").click(function(){
        $(".expert-info").addClass("show");
        $(".overlay").addClass("show");
        $("body").addClass("add-fix");
    });
    // $(".btn-shopping").click(function(){
    //     $(".cart-drawer").addClass("show");
    //     $(".overlay").addClass("show");
    //     $("body").addClass("add-fix");
    // });    
    $(".close-btn").click(function(){
        $(".filter-sidebar").removeClass("show");
        $(".cart-drawer").removeClass("show");
        $(".expert-info").removeClass("show");
        $(".overlay").removeClass("show");
        $("body").removeClass("add-fix");
    });
    $(".overlay").click(function(){
        $(".filter-sidebar").removeClass("show");
        $(".cart-drawer").removeClass("show");
        $(".expert-info").removeClass("show");
        $(".overlay").removeClass("show");
        $("body").removeClass("add-fix");
    });
    $(".filters-btn").click(function(){
        $(".filter-sidebar").addClass("show");
        $(".overlay").addClass("show");
        $("body").addClass("add-fix");
    });    
    

    /* **** header **** */
    // $(".navbar-toggler").click(function(){
    //     $(".mobile-navbar-nav").toggleClass("show");
    //     $(".overlay").toggleClass("show");
    //     $("body").toggleClass("add-fix");
    // });
    // $(".close-btn").click(function(){
    //     $(".mobile-navbar-nav").removeClass("show");
    //     $(".overlay").removeClass("show");
    //     $("body").removeClass("add-fix");
    // });
    // $(".mobile-navbar-nav .navbar-nav ul li a").click(function(){
    //     $(".mobile-navbar").addClass("sub-menu");
    //     $(this).parents('.dropdown').addClass("show");
    // });
    // $(".back-menu").click(function(){
    //     $(".mobile-navbar").removeClass("show");
    //      $(this).parents('.dropdown').removeClass("show");
    // });

 

  // $(".navbar-toggler").click(function(){
  //       $(".navbar-drawer").toggleClass("show");
  //       $(".overlay").toggleClass("show");
  //       $("body").toggleClass("add-fix");
  //   });
  //   $(".close-btn, .overlay").click(function(){
  //       $(".navbar-drawer").removeClass("show");
  //       $(".overlay").removeClass("show");
  //       $("body").removeClass("add-fix");
  //   });
  //   // $(".navbar-drawer .navbar-links li.nav-item .nav-link").click(function(){
  //   //     $(this).siblings().addClass("show");
  //   // });
  //   $(".back-inner-drawer").click(function(){
  //       $(this).parent().removeClass("show");
  //   });
  //   $(".inner-drawer ul li .nav-inner-links").click(function(){
  //       $(this).siblings().addClass("show");
  //   });
    /* **** End header **** */
});


// close cart drawer script start
  $(document).on("click", function(e) {
    // console.log(e.target.className);
    // console.log(e.target.tagName);
    if(e.target.className == 'cart-drawer__overlay'){
         $(document).find('.drawer').removeClass('active');
        document.body.classList.remove('overflow-hidden');
    }
});


$(document).ready(function () {  

  $(function() {
    // Owl Carousel
    var owl = $(".gloves-owl");
    owl.owlCarousel({
      items: 7,
      margin: 18,
      loop: false,
      nav: true,
      dots: false,
      autoWidth:true,
      navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
      autoplayTimeout: 3000,
          smartSpeed: 600,
  		responsive:{
  			0:{
  				items:2,
                  autoplay:true,
                  margin: 10,
  			},
  			575:{
  				items:4,
                  autoplay:true,
                  margin: 10,
  			},
  			768:{
  				items:2,
  			},
  			991:{
  				items:4
  			},
  			1366:{
  				items:7
  			},
  			1440:{
  				items:7
  			}
  		}
    });
  });
});
$(document).ready(function () {  
$('.owl-sponsor-slider').owlCarousel({
    loop:true,
  items: 5,
    margin:100,
    nav:true,
    dots: false,
      
      navText : ["<img src='https://rumble-store-b2c.myshopify.com/cdn/shop/files/slide-left.svg?v=1710745127' alt=''>","<img src='https://rumble-store-b2c.myshopify.com/cdn/shop/files/slide-right.svg?v=1710745126' alt=''>"],
      autoplayTimeout: 3000,
          smartSpeed: 600,
    responsive:{
        0:{
  				items:2,

                  margin: 20,
  			},
  			575:{
  				items:2,
                  margin: 20,
  			},
  			768:{
  				items:3,
  			},
  			991:{
  				items:4
  			},
  			
  			1440:{
  				items:5
  			}
    }
});



    // cart drawer script
     // Add to cart button default variant script
       $(document).on("click", ".drawer .drower-product-wrap .prd-box .btn-cart.in-stock", function(){
         console.log($(this));
          var variant_id = $(this).data('id');
          console.log(variant_id);
          // Cart Ajax Function
          Shopify.queue = [];
          
          var array = [variant_id]; 
          var str = array.toString();
          var newArray = str.split(",");
          console.log(newArray);
          for (var i = 0; i < newArray.length; i++) {
           product = newArray[i];
          
           Shopify.queue.push({
             variantId: product,
           });
           }
          Shopify.moveAlong = function() {
           // If we still have requests in the queue, let's process the next one.
           if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var req = request.variantId;
              var qty = 1;
              var data = 'id='+ req + '&quantity='+qty;
              $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  dataType: 'json',
                  data: data,
                  success: function(res){
                    Shopify.moveAlong();
                    console.log(res);
                      jQuery.getJSON('/cart.js', function(cart) {
                       setTimeout(function(){
                          $.ajax({
                              url: '/?section_id=cart-drawer',
                              type: 'GET',
                              dataType: 'html',
                              success:function(carthtml) {
                                $('cart-drawer').html($(carthtml).find('cart-drawer').html());
                                $(document).find('.drawer').addClass('animate active');
                                $('body').addClass('overflow-hidden');
                              }
                          });
                       },200);
                    });
                     
                  },
                  error: function(){
                      if (Shopify.queue.length){
                        Shopify.moveAlong();
                      } else {
                    }
                  }
              });
            }
            else {
            }
          };
          Shopify.moveAlong();                          
    });
  
  });
// close cart drawer script end

// new search drawer 
/* **** Search *** */
    $(".navbar-light .navbar-nav-right .form-group .form-control, .btn-search-drawer, .search-modal__form").click(function () {
        $(".search-drawer").toggleClass("show");
        $(".drawer-overlay").toggleClass("show");
        $("body").toggleClass("search-open");
    });
    $(".drawer-overlay, .search-drawer .drawer-search a").click(function () {
        $(".search-drawer").removeClass("show");
        $(".drawer-overlay").removeClass("show");
        $("body").removeClass("search-open");
    });
    /* **** End Search *** */
// new search drawer 
